




































































import VueOptions from '@utils/VueOptions'
import TagBar from '@ui/TagBar'

settings =
  name: "CampaignCard"
  vue:
    props: ['campaign', 'actions']

    components: { TagBar }

    computed:
      brand: -> @campaign.brand_info
      brandLogoURL: -> @brand.logo
      logoLetter: -> @brand.name.charAt(0)

      states: -> @campaign.target.geo.state_list
      dmas: -> @campaign.target.geo.dma_list
      locations: ->
        list = [...@states, ...@dmas]
        {
          display: list,
          hidden: list.slice(2)
        }

      hasActions: -> !!Object.values(@actions).length

    methods:
      hiNavToEditStep: (step) -> @$router.push { name: 'CampaignEditWizard', params: { campaignId: @campaign.id, step } }
      hiNavToStage: (stage) -> @$router.push { name: stage, params: { campaignId: @campaign.id }}
      hiRemoveCampaign: -> @actions.remove?(@campaign)

      hiDropdownAction: (command) ->
        switch command
          when 'duplicate' then @actions.duplicate(@campaign)
          when 'remove' then @actions.remove(@campaign)

export default VueOptions.vue settings
